import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { calendarApi } from './calendarApi';

/**
 * The link at the foot of the weekly digest.
 *
 * TURNS OFF THE EMAIL, NEVER THE ACCOUNT. Somebody who does not want a weekly
 * email is still a paying subscriber, and a link in an email must not be able to
 * cancel what they pay for. The page says so plainly, because the word
 * "unsubscribe" reasonably makes people think it did the other thing.
 *
 * It needs no login: the token in the URL is what authenticates it, which is the
 * only way a link in an email can work.
 */
function CalendarUnsubscribe() {
  const { token } = useParams();
  const [state, setState] = useState('working');
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        await calendarApi(`/unsubscribe/${encodeURIComponent(token)}`, { method: 'POST' });
        if (!cancelled) setState('done');
      } catch (err) {
        if (!cancelled) {
          setError(err.message);
          setState('failed');
        }
      }
    })();

    return () => { cancelled = true; };
  }, [token]);

  return (
    <div style={{ maxWidth: '520px', margin: '0 auto', padding: '64px 16px' }}>
      <h1 style={{ color: 'var(--color-heading)', fontSize: '1.4rem' }}>Weekly calendar email</h1>

      {state === 'working' && (
        <p style={{ color: 'var(--color-text-light)' }}>One moment.</p>
      )}

      {state === 'done' && (
        <>
          <p style={{ color: 'var(--color-text)' }}>
            Done. You will not get the weekly email again.
          </p>
          <p style={{ color: 'var(--color-text-light)' }}>
            Your subscription is untouched and the calendar still works exactly as it did.
            You can turn the email back on any time from your preferences.
          </p>
        </>
      )}

      {state === 'failed' && (
        <p style={{ color: 'var(--color-text-light)' }}>
          {error} This link may already have been used. Nothing about your subscription
          has changed either way.
        </p>
      )}
    </div>
  );
}

export default CalendarUnsubscribe;
